var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGaussian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.720px",
    height: "15.184px",
    viewBox: "0 -789 979 839",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MJX-6-TEX-C-4E",
    d: "M343 705Q358 705 358 698Q360 696 370 658T411 524T484 319Q536 174 590 82L595 73L615 152Q646 274 683 407Q729 571 752 637T799 727Q852 780 937 788Q939 788 947 788T958 789H962Q979 789 979 765Q979 722 951 692Q942 683 924 683Q888 681 859 672T818 654T803 639Q784 608 708 322T631 15Q631 14 630 15Q630 17 629 15Q628 14 628 12Q621 -4 601 -17T560 -31Q550 -31 546 -28T530 -7Q484 67 458 123T398 272Q352 392 314 514L306 535V534Q306 533 296 488T272 379T234 239T185 100T127 -7T61 -50Q34 -50 4 -34T-27 8Q-27 33 -12 61T18 90Q21 90 36 77T87 57H92Q109 57 123 78T162 173Q206 299 232 417T265 599T276 667Q284 681 304 693T343 705Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    transform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "TeXAtom"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mi"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MJX-6-TEX-C-4E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaussian);
export default __webpack_public_path__ + "static/media/gaussian.02c6cdeee180c4afd0a2d4230c58b9a3.svg";
export { ForwardRef as ReactComponent };